import { css } from '@emotion/react';
import {
  type ReactNode, useState,
} from 'react';
import { LayeredPortalContext } from './layeredPortal.context';

const hostStyle = css({
  display: 'contents',
});

type LayeredPortalHostComponentProps = {
  children: ReactNode;
};

export const LayeredPortalHostComponent = ({ children }: LayeredPortalHostComponentProps) => {
  const [hostElement, setHostElement] = useState<HTMLDivElement | null>(null);

  return (
    <LayeredPortalContext.Provider value={hostElement}>
      {children}
      <div ref={setHostElement} css={hostStyle} />
    </LayeredPortalContext.Provider>
  );
};
